import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38ca9b67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"inline-block","margin-right":"10px"} }

import { ref, computed, watch } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cluePush } from '@/api/marketing/marketingManage'
import type { ClueManage } from '@/typings/api/marketingManage'
import type { PropType } from 'vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import BatchUserList from '../BatchUserList/index.vue'
import { cloneDeep } from 'lodash-es'
import { bool } from 'vue-types'
import { shareInfo } from '@dc-platform/dc-interaction'

const __default__ = { name: 'LaunchButton' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Array as PropType<ClueManage[]>,
    default: () => {
      return []
    }
  },
  type: {
    type: String,
    default: 'customer' // customer 客户 clue 线索
  },
  title: {
    type: String
  },
  tips: {
    type: String // 描述
  },
  appId: {
    type: String,
    default: 'cos_fbu'
  }
},
  emits: ['success'],
  setup(__props, { emit: __emit }) {

const props = __props
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const form = ref<any>({})
const emit = __emit
const loginUser = shareInfo.getUserInfo() || {}
const acceptClueSystem = computed(() => {
  if (props.appId === 'cos_fbu') {
    return [
      {
        value: 'cos_fbu',
        label: '谷仓'
      },
      {
        value: 'cos_ofbu',
        label: '谷仓海外'
      }
    ]
  }
  return [
    {
      value: 'cos_lbu',
      label: '云途'
    }
  ]
})
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    form.value.batch.principalRegion = undefined
    loading.value = true
    savePeopleMessage()
    cluePush({ batch: form.value.batch })
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('投放处理中，结果稍后通过飞书消息提醒')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
// 保存人员信息到本地
const savePeopleMessage = () => {
  const { conductor, follower, customerRegion } = form.value.batch[0]
  let init = {}
  if (!loginUser.work_code) {
    return
  }
  const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
  if (leadManagePeople) {
    init = JSON.parse(leadManagePeople)
  }
  if (!init[loginUser.work_code]) {
    init[loginUser.work_code] = {}
  }
  init[loginUser.work_code][props.appId] = {
    conductor,
    follower,
    customerRegion
  }
  localStorage.setItem('dc-cos-lbu-leadManage', JSON.stringify(init))
}
const showModal = () => {
  // 验证数量
  if (!props.data || props.data.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 谷仓市场线索投放不过滤线索类型
  if (props.appId !== 'cos_fbu') {
    const errorData = props.data.find((item) => item.clueType !== 2)
    if (errorData) {
      DcMessage.error('请选择有效线索进行投放！')
      return
    }
  }
  form.value.batch = []
  // 验证线索 已投放到两个端的不能投放
  visible.value = true
  // 设置clueIdList
  // 处理数组（对接人字段取创建人）
  // 处理加载
  const result = props.data.reduce((prev: any, cur: any) => {
    const { expectPushInfo, createBy, createByName, clueId, customerName, receiver } = cur
    const newInfo = []
    const init = {
      cos_lbu: {
        code: 'zt20309',
        name: '李科燕'
      },
      cos_fbu: {
        code: 'zt18054',
        name: '覃恒梅'
      }
    }
    if (expectPushInfo && expectPushInfo.length) {
      expectPushInfo.forEach((e: any, i: number) => {
        newInfo.push({
          conductor: createBy,
          conductorName: createByName,
          customerRegion: e.region,
          receiver: e.acceptor ? e.acceptor : props.appId,
          subdomain: e.acceptor ? e.acceptor : props.appId,
          follower: e.follower,
          followerName: e.followerName,
          clueId,
          pageId: clueId + '_' + i,
          customerName
        })
      })
    } else {
      // 没有预投放信息的话获取默认配置
      let initPeople = {
        conductor: init[props.appId].code,
        conductorName: init[props.appId].name,
        follower: undefined,
        customerRegion: undefined
      }
      const leadManagePeople = localStorage.getItem('dc-cos-lbu-leadManage')
      if (leadManagePeople) {
        const leadManagePeopleObj = JSON.parse(leadManagePeople)
        const userConductor = leadManagePeopleObj[loginUser.work_code]
        if (userConductor && userConductor[props.appId]) {
          initPeople = userConductor[props.appId]
        }
      }
      newInfo.push({
        customerName,
        clueId,
        follower: initPeople.follower,
        customerRegion: initPeople.customerRegion,
        conductor: initPeople.conductor,
        conductorName: initPeople.conductorName,
        receiver: receiver,
        subdomain: receiver,
        pageId: clueId
      })
    }
    return [...prev, ...newInfo]
  }, [])
  loading.value = true
  setTimeout(() => {
    form.value.batch = cloneDeep(result)
    loading.value = false
  }, 500)
}
// 删除
const handleDelete = (index: number) => {
  form.value.batch.splice(index, 1)
}
/// 选择负责人后吧该负责人的区域带出来
const principalChange = (record: any, user: any) => {
  if (props.appId === 'cos_fbu' && user) {
    record.principalRegion = user.deptId
    record.customerRegion = user.deptId
  }
}
/// 谷仓为了选择区域后把不是该区域的负责人给清空
const regionChange = (record: any, region: any) => {
  if (props.appId === 'cos_fbu' && region && region.custom && region.custom !== record.principalRegion) {
    record.follower = undefined
    record.followerName = undefined
  }
}
const targetChange = (record: any) => {
  if (props.appId === 'cos_fbu' && record && record.receiver) {
    record.subdomain = record.receiver
  }
}
const columns = computed(() => {
  const init = [
    {
      title: '客户名称',
      dataIndex: 'customerName'
    },
    {
      title: '投放到',
      dataIndex: 'receiver',
      width: 100
    },
    {
      title: '客户区域',
      dataIndex: 'customerRegion',
      width: 140
    },
    {
      title: '对接人',
      dataIndex: 'conductor',
      width: 120
    },
    {
      title: '客户负责人',
      dataIndex: 'follower',
      width: 120
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 70
    }
  ]
  if (props.appId === 'cos_fbu') {
    return init
  } else {
    return init.filter((v) => v.dataIndex !== 'customerRegion')
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, { onClick: showModal }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }),
    _createVNode(_component_cos_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "投放",
      class: "cluePush",
      width: "1200px",
      onOk: handleSubmit,
      confirmLoading: loading.value
    }, {
      default: _withCtx(() => [
        (visible.value)
          ? (_openBlock(), _createBlock(_component_a_form, {
              key: 0,
              model: form.value,
              ref_key: "formRef",
              ref: formRef,
              class: "launchTable"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_cos_table, {
                  columns: columns.value,
                  rowKey: "pageId",
                  dataSource: form.value.batch,
                  needPage: false,
                  ref: "tableRef",
                  loading: loading.value,
                  tableId: "launchTable"
                }, {
                  bodyCell: _withCtx(({ column, record, index }) => [
                    (column.dataIndex === 'receiver')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          name: ['batch', index, 'receiver'],
                          rules: {
                  required: true,
                  message: '请选择'
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosSelect, {
                              options: acceptClueSystem.value,
                              value: record.receiver,
                              "onUpdate:value": ($event: any) => ((record.receiver) = $event),
                              allowClear: false,
                              onChange: ($event: any) => (targetChange(record))
                            }, null, 8, ["options", "value", "onUpdate:value", "onChange"])
                          ]),
                          _: 2
                        }, 1032, ["name"]))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'customerRegion')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          name: ['batch', index, 'customerRegion'],
                          rules: {
                  required: record.receiver === 'cos_fbu' ? true : false,
                  message: '请选择'
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CustomerAreaCascader, {
                              appId: "cos_fbu",
                              deptInfoId: "815717",
                              value: record.customerRegion,
                              "onUpdate:value": ($event: any) => ((record.customerRegion) = $event),
                              placeholder: "请选择客户区域",
                              onChange: (value) => regionChange(record,value)
                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                          ]),
                          _: 2
                        }, 1032, ["name", "rules"]))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'conductor')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 2,
                          name: ['batch', index, 'conductor'],
                          rules: {
                  required: true,
                  message: '请选择'
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BatchUserList, {
                              value: record.conductor,
                              "onUpdate:value": ($event: any) => ((record.conductor) = $event),
                              label: record.conductorName,
                              "onUpdate:label": ($event: any) => ((record.conductorName) = $event),
                              placeholder: "请选择",
                              allowClear: ""
                            }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label"])
                          ]),
                          _: 2
                        }, 1032, ["name"]))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'follower')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 3,
                          name: ['batch', index, 'follower']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(BatchUserList, {
                              value: record.follower,
                              "onUpdate:value": ($event: any) => ((record.follower) = $event),
                              label: record.followerName,
                              "onUpdate:label": ($event: any) => ((record.followerName) = $event),
                              placeholder: "请选择",
                              onChange: (value) => principalChange(record,value),
                              allowClear: ""
                            }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label", "onChange"])
                          ]),
                          _: 2
                        }, 1032, ["name"]))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'action')
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 4,
                          type: "link",
                          onClick: ($event: any) => (handleDelete(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 删除 ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["columns", "dataSource", "loading"])
              ]),
              _: 1
            }, 8, ["model"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "confirmLoading"])
  ]))
}
}

})